import PropTypes from "prop-types";
import React, { useState } from "react";
import styled from "styled-components";
import { Container } from "./layoutComponents";

const Header = ({ className }) => {
  const [open, setOpen] = useState(false);
  return (
    <header className={className}>
      <Container className="row between">
        <div>
          <h1
            className="hideDesktop"
            style={{ marginTop: -5, fontSize: "2.2rem" }}
          >
            QIAcuity
          </h1>
        </div>
        <nav className={`${open ? "show" : ""}`}>
          <a
            className="navItem active"
            id="nav-start"
            href="#start"
            onClick={() => setOpen(false)}
          >
            Start
          </a>
          <a
            className="navItem"
            id="nav-components"
            href="#components-start"
            onClick={() => setOpen(false)}
          >
            Components
          </a>
          <a
            className="navItem"
            id="nav-features"
            href="#features-accuracy"
            onClick={() => setOpen(false)}
          >
            Features and Benefits
          </a>
          <a
            className="navItem"
            id="nav-workflow"
            href="#workflow-preparation"
            onClick={() => setOpen(false)}
          >
            Workflow
          </a>
          <a
            className="navItem"
            id="nav-contact"
            href="#contact"
            onClick={() => setOpen(false)}
          >
            Contact
          </a>
        </nav>
        <div
          className={`burger  ${open ? "active" : ""}`}
          onClick={() => setOpen(!open)}
        >
          <div
            className={` dots ${open ? "on" : ""}`}
            onClick={() => setOpen(!open)}
          >
            <span></span>
          </div>
        </div>
      </Container>
    </header>
  );
};

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

const StyledHeader = styled(Header)`
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 22px 0 0 0;
  height: 75px !important;
  // box-shadow: 0 0 0.5rem 0.0625rem rgba(0, 0, 0, 0.4);
  width: 100vw;
  z-index: 950;
  -webkit-transform: translateZ(0);

  @media only screen and (max-width: 768px) {
    height: 40px !important;
    padding 0;
  }

  .burger {
    position: absolute;
    top: 0px;
    right: -5px;
    width: 40px;
    height: 40px;
    @media only screen and (min-width: 769px) {
      display: none;
    }
  }

  .row {
    display: flex!important;
  }

  .between {
    justify-content: space-between!important;;
  }

  nav {
    margin-top: 5px;
    height: 40px;
    a {
      margin-left: 22px;
      font-size: 1.1rem;
      color: ${p => p.theme.colors.text};
      &:hover,
      &.active {
        color: ${p => p.theme.colors.highlight};
      }
    }
    @media only screen and (max-width: 768px) {
      position: fixed;
      left: 0px;
      top: 40px;
      width: 100vw;
      height: 100vh;
      margin-top: 0px;
      background: rgba(255, 255, 255, 0.7);
      display: flex!important;
      flex-direction: column;
      backdrop-filter: blur(12px);
      transform: translate3d(100vw, 0, 0);
      transition: 300ms transform ease-in-out;
      z-index: 500;

      a {
        margin-left: 32px;
        font-size: 1.5rem;
        color: ${p => p.theme.colors.link};
        padding: 20px 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.25);
      }
      &.show {
        transform: translate3d(0, 0, 0) !important;
      }
    }
  }

  h1,
  a,
  img {
    margin: 0;
  }

  .logo {
    position: relative;
    width: 80px;
    height: auto;
    background: #fff;
    padding: 0 11px;
    margin-left: -11px;

    &:before {
      content: "";
      position: fixed;
      left: 0px;
      top: 65px;
      width: 100vw;
      height: 1px;
      background: ${p => p.theme.colors.primary};
      z-index: 0;
    }
  }

  .dots {
    width:60px;
    height:30px;
    border:none;
    background:transparent;
    position:relative;
    cursor:pointer;
    transform: scale(0.7);
    transition: 300ms transform ease-in-out;
    &.on {
      transform: scale(0.5);
    }
    &:focus {
      outline:none;
    }
    
    &.dots {
      &:after,
      &:before,
      span {
        width:10%;
        height:20%;
        border-radius:100px;
        position:absolute;
        left:0px;
        background: ${p => p.theme.colors.highlight};
        transform:rotate(0deg);
        transition: all 0.4s;
  
        left: 1%;
        right: 1%;
        margin: 0 auto;
  
      }
  
      &:after,
      &:before {
        content:"";
      }
  
      &:after {
        top:-10%;
        margin-top:0px;
        
      }
  
      &:before {
        bottom:-10%;
        margin-bottom:0px;
      }
  
      span {
        top:50%;
        margin-top:-2px;
      }
  
      &.on {
  
        &:after {
          transform:rotate(135deg)translate(9px,-9px);
          width: 100%;
        }
  
        &:before { 
          transform:rotate(225deg);
          bottom:50%;
          margin-bottom:-2px;
          width: 100%;
        }
  
        span {
          transform:rotate(135deg);
        }
  
      }
    }
  
  
`;

export default StyledHeader;
